<script context="module" lang="ts">
    import pDebounce from "p-debounce"
    import { getDBEntries, getDBEntry } from "../../api"

    // TODO: check ssr

    const medialibCache: { [id: string]: MedialibEntry } = {}

    let loadQueue: string[] = []
    async function loadMedialibEntry(id: string): Promise<MedialibEntry> {
        if (medialibCache[id]) return medialibCache[id]
        loadQueue.push(id)
        await processQueueDebounced()
        return medialibCache[id]
    }

    const processQueue = async () => {
        // console.log("processQueue", loadQueue.length)
        if (loadQueue.length) {
            const _ids = loadQueue
            loadQueue = []
            const entries = await getDBEntries("medialib", { _id: { $in: _ids } })
            entries.forEach((entry) => {
                medialibCache[entry.id] = entry
            })
        }
    }

    const processQueueDebounced = pDebounce(processQueue, 50)
</script>

<script lang="ts">
    import { apiBaseURL } from "../../config"
    import { apiBaseOverride } from "../store"

    export let id: string
    export let noPlaceholder: boolean = false

    let loading = true
    let entry: MedialibEntry
    let fileSrc: string

    async function loadFile() {
        loading = true
        entry = null
        fileSrc = null
        try {
            entry =
                typeof window !== "undefined" ? await loadMedialibEntry(id) : await getDBEntry("medialib", { _id: id })
            if (entry?.file?.src) {
                fileSrc = ($apiBaseOverride ? $apiBaseOverride : apiBaseURL) + "medialib/" + id + "/" + entry.file.src

                // preload png and jpg images and wait for them to load
                // if (typeof window !== "undefined" && entry.file.type?.match(/^image\/(png|jpe?g)/)) {
                //     const img = new Image()
                //     img.src = fileSrc
                //     await new Promise((resolve, reject) => {
                //         img.onload = resolve
                //         img.onerror = reject
                //     })
                // }
            }
        } catch (e) {
            console.error(e)
        }
        loading = false
    }

    $: if (id) loadFile()
</script>

{#if id}
    {#if loading}
        {#if !noPlaceholder}
            <slot name="loading" {entry} src="{fileSrc}" />
        {/if}
    {:else if entry}
        <slot {entry} src="{fileSrc}" />
    {:else if !noPlaceholder}
        <slot name="not-found" />
    {/if}
{/if}
